/**
 * 全局水印生成与注入
 * @param {Object} options - 水印配置项（可选）
 * @param {string} options.text - 水印文字，默认'V策财经'
 * @param {number} options.opacity - 水印透明度，默认0.1
 * @param {string} options.font - 水印字体，默认'14px Microsoft Yahei'
 * @param {number} options.rotate - 水印旋转角度（弧度），默认-Math.PI/4（-45度）
 * @param {number} options.size - 水印画布大小，默认100（宽高）
 */
function initGlobalWatermark (options = {}) {
  // 默认配置
  const defaultOptions = {
    text: "V策财经",
    opacity: 0.1,
    font: "14px Microsoft Yahei",
    rotate: -Math.PI / 4,
    size: 100,
  };
  const config = { ...defaultOptions, ...options };

  // 全局变量，用于防篡改控制
  let watermarkObserver = null;
  let isReinjecting = false;

  // 生成水印Canvas
  function createWatermarkCanvas () {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.height = config.size; // 画布大小
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.globalAlpha = config.opacity; // 透明度
    ctx.font = config.font; // 字体
    ctx.translate(config.size / 2, config.size / 2); // 平移到画布中心
    ctx.rotate(config.rotate); // 旋转
    ctx.fillText(config.text, 0, 0); // 绘制文字
    return canvas;
  }

  // 创建水印容器（全屏固定定位）
  function createWatermarkContainer (canvas) {
    // 避免重复创建水印容器
    const existingWatermark = document.getElementById("global-watermark");
    if (existingWatermark) {
      existingWatermark.remove();
    }

    const watermarkDiv = document.createElement("div");
    watermarkDiv.id = "global-watermark";
    // 将Canvas转为base64背景图，实现水印平铺
    const base64Url = canvas.toDataURL("image/png");
    Object.assign(watermarkDiv.style, {
      position: "fixed", // 固定定位，跟随页面滚动
      top: "0",
      left: "0",
      width: "100vw", // 视口宽度
      height: "100vh", // 视口高度
      pointerEvents: "none", // 禁止水印容器拦截鼠标事件（关键）
      zIndex: "999999", // 置顶显示，避免被页面元素遮挡
      backgroundImage: `url(${base64Url})`,
      backgroundRepeat: "repeat", // 平铺水印
      backgroundSize: `${config.size}px ${config.size}px`, // 水印背景大小与画布一致
    });
    return watermarkDiv;
  }

  // 注入水印到页面，并添加防删除监听
  function injectWatermark () {
    // 如果正在重新注入，则跳过
    if (isReinjecting) return;
    isReinjecting = true;

    // 清理旧的观察者，防止重复监听
    if (watermarkObserver) {
      watermarkObserver.disconnect();
      watermarkObserver = null;
    }

    const canvas = createWatermarkCanvas();
    const watermarkDiv = createWatermarkContainer(canvas);
    document.body.appendChild(watermarkDiv);

    // 监听水印容器被删除，自动重新创建（防篡改）
    watermarkObserver = new MutationObserver((mutations) => {
      // 检查水印是否还存在
      const currentWatermark = document.getElementById("global-watermark");
      if (currentWatermark) {
        // 水印还存在，继续观察
        return;
      }

      // 检查是否被删除
      let isRemoved = false;
      mutations.forEach((mutation) => {
        mutation.removedNodes.forEach((node) => {
          if (node.id === "global-watermark") {
            isRemoved = true;
          }
        });
      });

      // 如果被删除，重新注入（使用setTimeout避免爆栈）
      if (isRemoved) {
        // 先停止观察，避免重复触发
        if (watermarkObserver) {
          watermarkObserver.disconnect();
          watermarkObserver = null;
        }

        // 使用setTimeout避免递归调用
        setTimeout(() => {
          isReinjecting = false;
          injectWatermark();
        }, 50);
      }
    });

    // 只监听body的直接子节点变化（减少性能开销）
    watermarkObserver.observe(document.body, {
      childList: true,
      subtree: false, // 关键修改：只监听直接子节点，避免subtree导致过多事件
    });

    // 重置注入状态
    setTimeout(() => {
      isReinjecting = false;
    }, 100);
  }

  // 执行注入
  injectWatermark();
}

// 全局暴露方法（方便后续动态更新水印）
window.initGlobalWatermark = initGlobalWatermark;

// 初始化全局水印（使用默认配置）
// initGlobalWatermark();
